<div class="container mx-auto px-4 py-6">
  <!-- Header -->
  <div class="mb-8">
    <h1 class="text-2xl font-bold text-gray-900">Nueva Reversión de Retiro</h1>
    <p class="text-gray-600 mt-1">Revertir cartera castigada y reactivar inscripción o crear nueva</p>
  </div>

  <!-- Stepper Dinámico -->
  <div class="mb-8">
    <div class="flex items-center justify-between">
      <!-- Flujo simple (mismo proyecto): 5 pasos -->
      <ng-container *ngIf="destinationForm.get('continueInSameProject')?.value">
        <div class="flex items-center" *ngFor="let step of [1, 2, 3, 4, 5]; let i = index">
          <div class="flex items-center">
            <div 
              [class.bg-green-500]="currentStep === 5 && operationSuccess && step === 5"
              [class.bg-red-600]="currentStep === 5 && !operationSuccess && step === 5"
              [class.bg-green-600]="(currentStep >= step && step < 5) || (currentStep === 5 && step < 5)"
              [class.bg-gray-200]="currentStep < step && !(currentStep === 5 && step === 5)"
              [class.text-white]="currentStep >= step || (currentStep === 5 && step === 5)"
              [class.text-gray-600]="currentStep < step && !(currentStep === 5 && step === 5)"
              class="w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center font-semibold text-sm">
              <span *ngIf="!(currentStep === 5 && step === 5)">{{ step }}</span>
              <svg *ngIf="currentStep === 5 && step === 5 && operationSuccess" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
              </svg>
              <svg *ngIf="currentStep === 5 && step === 5 && !operationSuccess" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </div>
            <span class="ml-1 text-xs font-medium hidden lg:inline" 
                  [ngClass]="{'text-green-600': currentStep >= step, 'text-gray-500': currentStep < step}">
              {{ step === 1 ? 'Seleccionar' : step === 2 ? 'Revisar' : step === 3 ? 'Destino' : step === 4 ? 'Confirmar' : 'Resultado' }}
            </span>
          </div>
          <div *ngIf="i < 4" class="w-8 md:w-12 h-1 mx-1 md:mx-2" 
               [ngClass]="{'bg-green-600': currentStep > step, 'bg-gray-200': currentStep <= step}"></div>
        </div>
      </ng-container>

      <!-- Flujo extendido (nuevo proyecto): 7 pasos -->
      <ng-container *ngIf="!destinationForm.get('continueInSameProject')?.value">
        <div class="flex items-center" *ngFor="let step of [1, 2, 3, 4, 5, 6, 7]; let i = index">
          <div class="flex items-center">
            <div 
              [class.bg-green-500]="currentStep === 7 && operationSuccess && step === 7"
              [class.bg-red-600]="currentStep === 7 && !operationSuccess && step === 7"
              [class.bg-green-600]="(currentStep >= step && step < 7) || (currentStep === 7 && step < 7)"
              [class.bg-gray-200]="currentStep < step && !(currentStep === 7 && step === 7)"
              [class.text-white]="currentStep >= step || (currentStep === 7 && step === 7)"
              [class.text-gray-600]="currentStep < step && !(currentStep === 7 && step === 7)"
              class="w-7 h-7 md:w-9 md:h-9 rounded-full flex items-center justify-center font-semibold text-xs">
              <span *ngIf="!(currentStep === 7 && step === 7)">{{ step }}</span>
              <svg *ngIf="currentStep === 7 && step === 7 && operationSuccess" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
              </svg>
              <svg *ngIf="currentStep === 7 && step === 7 && !operationSuccess" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </div>
            <span class="ml-1 text-xs font-medium hidden xl:inline" 
                  [ngClass]="{'text-green-600': currentStep >= step, 'text-gray-500': currentStep < step}">
              {{ step === 1 ? 'Seleccionar' : step === 2 ? 'Revisar' : step === 3 ? 'Destino' : step === 4 ? 'Valor' : step === 5 ? 'Plan' : step === 6 ? 'Confirmar' : 'Resultado' }}
            </span>
          </div>
          <div *ngIf="i < 6" class="w-6 md:w-8 h-1 mx-1" 
               [ngClass]="{'bg-green-600': currentStep > step, 'bg-gray-200': currentStep <= step}"></div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Paso 1: Seleccionar inscripción retirada -->
  <div *ngIf="currentStep === 1" class="bg-white rounded-lg shadow-md p-6">
    <h2 class="text-lg font-semibold mb-4">Buscar Inscripción Retirada</h2>
    
    <form [formGroup]="searchForm" (ngSubmit)="searchParticipant()" class="mb-6">
      <div class="flex gap-4">
        <input 
          type="text" 
          formControlName="searchTerm"
          placeholder="Buscar por nombre o documento..."
          class="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent">
        <button 
          type="submit" 
          [disabled]="isSearching || searchForm.invalid"
          class="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400">
          <span *ngIf="isSearching">Buscando...</span>
          <span *ngIf="!isSearching">Buscar</span>
        </button>
      </div>
    </form>

    <!-- Lista de participantes -->
    <div *ngIf="searchPerformed && participants.length > 0" class="mb-6">
      <h3 class="text-sm font-medium text-gray-700 mb-2">Participantes encontrados:</h3>
      <div class="space-y-2 max-h-60 overflow-y-auto">
        <div 
          *ngFor="let p of participants" 
          (click)="selectParticipant(p)"
          [ngClass]="{'ring-2 ring-green-500 bg-green-50': selectedParticipantId === p.id}"
          class="p-3 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
          <div class="font-medium">{{ p.firstName }} {{ p.lastName }}</div>
          <div class="text-sm text-gray-500">{{ p.typeDocument }}: {{ p.documentId }}</div>
        </div>
      </div>
    </div>

    <!-- Lista de inscripciones retiradas -->
    <div *ngIf="withdrawnEnrollments.length > 0" class="mt-6">
      <h3 class="text-sm font-medium text-gray-700 mb-2">Inscripciones retiradas:</h3>
      <div class="space-y-3">
        <div 
          *ngFor="let e of withdrawnEnrollments"
          (click)="selectEnrollment(e)"
          class="p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors border-red-200 bg-red-50">
          <div class="flex justify-between items-start">
            <div>
              <div class="font-medium">{{ e.projectMnemonic }} - {{ e.projectName }}</div>
              <div class="text-sm text-gray-600">{{ e.participantName }}</div>
            </div>
            <span class="px-2 py-1 text-xs rounded-full bg-red-100 text-red-800">
              Retirada
            </span>
          </div>
          <div class="mt-2 text-sm">
            <span class="text-gray-600">Cartera castigada: </span>
            <span class="font-medium text-red-600">{{ e.currencySymbol }}{{ e.remainingBalance | number:'1.2-2' }}</span>
          </div>
          <div *ngIf="e.withdrawalReason" class="mt-1 text-sm text-gray-500">
            Razón: {{ e.withdrawalReason }}
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isLoading" class="text-center py-8">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600 mx-auto"></div>
    </div>
  </div>

  <!-- Paso 2: Revisar cuotas castigadas -->
  <div *ngIf="currentStep === 2 && selectedEnrollment" class="bg-white rounded-lg shadow-md p-6">
    <div class="mb-6">
      <h2 class="text-lg font-semibold">Revisar Cuotas Castigadas</h2>
      <p class="text-gray-600">{{ selectedEnrollment.participantName }} - {{ selectedEnrollment.projectName }}</p>
    </div>

    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Cuota</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Vencimiento</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Monto Original</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Pagado</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Pendiente</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Estado</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let pp of punishedInstallments" class="bg-red-50">
            <td class="px-4 py-3 text-sm font-medium text-gray-900">{{ pp.installmentNumber }}</td>
            <td class="px-4 py-3 text-sm text-gray-500">{{ pp.dueDate | date:'dd/MM/yyyy' }}</td>
            <td class="px-4 py-3 text-sm text-gray-900">{{ selectedEnrollment.currencySymbol }}{{ pp.amountToPay | number:'1.2-2' }}</td>
            <td class="px-4 py-3 text-sm text-green-600">{{ selectedEnrollment.currencySymbol }}{{ pp.amountPaid | number:'1.2-2' }}</td>
            <td class="px-4 py-3 text-sm text-red-600 font-medium">{{ selectedEnrollment.currencySymbol }}{{ pp.pendingAmount | number:'1.2-2' }}</td>
            <td class="px-4 py-3">
              <span class="px-2 py-1 text-xs rounded-full bg-red-100 text-red-800">Castigada</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mt-6 p-4 bg-green-50 rounded-lg">
      <div class="flex justify-between items-center">
        <span class="font-medium text-green-800">Total a revertir:</span>
        <span class="text-xl font-bold text-green-600">{{ selectedEnrollment.currencySymbol }}{{ totalPunishedAmount | number:'1.2-2' }}</span>
      </div>
      <div class="text-sm text-green-700 mt-1">{{ punishedInstallments.length }} cuotas serán reactivadas</div>
    </div>

    <div class="flex justify-between mt-6">
      <button (click)="prevStep()" class="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
        Anterior
      </button>
      <button (click)="nextStep()" class="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700">
        Continuar
      </button>
    </div>
  </div>

  <!-- Paso 3: Seleccionar destino -->
  <div *ngIf="currentStep === 3 && selectedEnrollment" class="bg-white rounded-lg shadow-md p-6">
    <h2 class="text-lg font-semibold mb-4">Seleccionar Destino</h2>
    
    <form [formGroup]="destinationForm">
      <div class="space-y-4">
        <!-- Opción: Mismo proyecto -->
        <div 
          (click)="destinationForm.patchValue({continueInSameProject: true})"
          class="p-4 border rounded-lg cursor-pointer transition-colors"
          [ngClass]="{'border-green-500 bg-green-50': destinationForm.get('continueInSameProject')?.value, 'border-gray-300 hover:bg-gray-50': !destinationForm.get('continueInSameProject')?.value}">
          <div class="flex items-start">
            <input 
              type="radio" 
              formControlName="continueInSameProject"
              [value]="true"
              class="mt-1 text-green-600 focus:ring-green-500">
            <div class="ml-3">
              <label class="font-medium text-gray-900">Continuar en el mismo proyecto</label>
              <p class="text-sm text-gray-500 mt-1">
                Las cuotas serán descastigadas y la inscripción será reactivada en el proyecto actual: 
                <strong>{{ selectedEnrollment.projectMnemonic }} - {{ selectedEnrollment.projectName }}</strong>
              </p>
            </div>
          </div>
        </div>

        <!-- Opción: Nuevo proyecto -->
        <div 
          (click)="destinationForm.patchValue({continueInSameProject: false})"
          class="p-4 border rounded-lg cursor-pointer transition-colors"
          [ngClass]="{'border-green-500 bg-green-50': !destinationForm.get('continueInSameProject')?.value, 'border-gray-300 hover:bg-gray-50': destinationForm.get('continueInSameProject')?.value}">
          <div class="flex items-start">
            <input 
              type="radio" 
              formControlName="continueInSameProject"
              [value]="false"
              class="mt-1 text-green-600 focus:ring-green-500">
            <div class="ml-3 flex-1">
              <label class="font-medium text-gray-900">Crear nueva inscripción en otro proyecto</label>
              <p class="text-sm text-gray-500 mt-1 mb-3">
                Se creará una nueva inscripción y las cuotas pendientes serán migradas al nuevo proyecto.
              </p>
              
              <div *ngIf="!destinationForm.get('continueInSameProject')?.value">
                <label class="block text-sm font-medium text-gray-700 mb-1">Seleccionar nuevo proyecto *</label>
                <p-dropdown 
                  formControlName="newProjectId" 
                  [options]="projects" 
                  optionLabel="name" 
                  optionValue="id"
                  [filter]="true" 
                  filterBy="name,projectId" 
                  placeholder="-- Seleccionar proyecto --" 
                  styleClass="w-full"
                  [showClear]="true">
                  <ng-template let-project pTemplate="item">
                    <div class="flex flex-col">
                      <span class="font-medium">{{project.name}}</span>
                      <span class="text-xs text-gray-500">{{project.projectId}}</span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="flex justify-between mt-6">
      <button (click)="prevStep()" class="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
        Anterior
      </button>
      <button 
        (click)="nextStep()" 
        [disabled]="!isDestinationValid()"
        class="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400">
        Continuar
      </button>
    </div>
  </div>

  <!-- Paso 4 (Mismo Proyecto): Confirmar -->
  <div *ngIf="currentStep === 4 && selectedEnrollment && destinationForm.get('continueInSameProject')?.value" class="bg-white rounded-lg shadow-md p-6">
    <h2 class="text-lg font-semibold mb-4">Confirmar Reversión</h2>
    
    <!-- Resumen -->
    <div class="bg-gray-50 rounded-lg p-4 mb-6">
      <h3 class="font-medium text-gray-700 mb-2">Resumen de la Reversión</h3>
      <div class="grid grid-cols-2 gap-4 text-sm">
        <div>
          <span class="text-gray-500">Participante:</span>
          <span class="ml-2 font-medium">{{ selectedEnrollment.participantName }}</span>
        </div>
        <div>
          <span class="text-gray-500">Proyecto original:</span>
          <span class="ml-2 font-medium">{{ selectedEnrollment.projectMnemonic }}</span>
        </div>
        <div>
          <span class="text-gray-500">Cuotas a revertir:</span>
          <span class="ml-2 font-medium">{{ punishedInstallments.length }}</span>
        </div>
        <div>
          <span class="text-gray-500">Monto total:</span>
          <span class="ml-2 font-medium text-green-600">{{ selectedEnrollment.currencySymbol }}{{ totalPunishedAmount | number:'1.2-2' }}</span>
        </div>
      </div>
    </div>

    <form [formGroup]="confirmForm" (ngSubmit)="submitReversal()">
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Razón de la reversión *</label>
        <textarea 
          formControlName="reason"
          rows="3"
          placeholder="Ingrese la razón de la reversión (mínimo 10 caracteres)"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent">
        </textarea>
      </div>

      <div class="mb-6">
        <label class="block text-sm font-medium text-gray-700 mb-1">Notas adicionales (opcional)</label>
        <textarea 
          formControlName="notes"
          rows="2"
          placeholder="Notas adicionales para auditoría"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent">
        </textarea>
      </div>

      <!-- Info -->
      <div class="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6">
        <div class="flex">
          <div class="flex-shrink-0">
            <svg class="h-5 w-5 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm text-blue-700">
              La inscripción será reactivada y las cuotas volverán a aparecer en la cartera regular.
            </p>
          </div>
        </div>
      </div>

      <div class="flex justify-between">
        <button type="button" (click)="prevStep()" class="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
          Anterior
        </button>
        <div class="flex items-center gap-3">
          <button type="button" (click)="cancel()" class="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
            Cancelar
          </button>
          <button 
            type="submit" 
            [disabled]="confirmForm.invalid || isSubmitting"
            class="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400 inline-flex items-center gap-2">
            <svg *ngIf="isSubmitting" class="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span *ngIf="isSubmitting">Procesando...</span>
            <span *ngIf="!isSubmitting">Confirmar Reversión</span>
          </button>
        </div>
      </div>
    </form>
  </div>

  <!-- Paso 4 (Nuevo Proyecto): Valor de la Nueva Inscripción -->
  <div *ngIf="currentStep === 4 && selectedEnrollment && !destinationForm.get('continueInSameProject')?.value" class="bg-white rounded-lg shadow-md p-6">
    <h2 class="text-lg font-semibold mb-4">Valor de la Nueva Inscripción</h2>
    <p class="text-gray-600 mb-6">Define el valor de la nueva inscripción para el proyecto <strong>{{ getSelectedProject()?.name }}</strong></p>

    <!-- Referencia de valores del proyecto -->
    <div class="bg-gray-50 p-4 rounded-lg mb-6">
      <p class="text-sm text-gray-500 mb-2">Valores base del proyecto seleccionado:</p>
      <div class="grid grid-cols-2 gap-4">
        <div>
          <span class="text-gray-600 text-sm">COP:</span>
          <span class="font-medium ml-2">{{ formatCurrency(getSelectedProject()?.inscriptionAmountCOP || getSelectedProject()?.inscriptionAmount || 0, 'COP') }}</span>
        </div>
        <div>
          <span class="text-gray-600 text-sm">USD:</span>
          <span class="font-medium ml-2">{{ formatCurrency(getSelectedProject()?.inscriptionAmountUSD || 0, 'USD') }}</span>
        </div>
      </div>
      <button 
        type="button"
        (click)="autofillFromProject()" 
        class="mt-3 text-sm text-blue-600 hover:text-blue-800 flex items-center gap-1">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
        </svg>
        Usar valores del proyecto
      </button>
    </div>

    <!-- Referencia del valor castigado original -->
    <div class="bg-red-50 p-4 rounded-lg mb-6 border-l-4 border-red-400">
      <p class="text-sm text-red-700">
        <strong>Valor castigado original:</strong> {{ selectedEnrollment.currencySymbol }}{{ totalPunishedAmount | number:'1.2-2' }}
      </p>
    </div>

    <form [formGroup]="valueForm">
      <!-- Inputs duales COP y USD -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Valor en COP *</label>
          <input 
            type="text" 
            formControlName="newTotalValueCOP"
            appCurrencyFormatter
            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            placeholder="$ 0">
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Valor en USD</label>
          <input 
            type="text" 
            formControlName="newTotalValueUSD"
            appCurrencyFormatter
            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            placeholder="USD$ 0">
        </div>
      </div>

      <!-- Selector de moneda principal -->
      <div class="mb-6">
        <label class="block text-sm font-medium text-gray-700 mb-1">Moneda principal para las cuotas</label>
        <p-dropdown 
          formControlName="currencyId"
          [options]="[{label: 'COP - Pesos Colombianos', value: 1}, {label: 'USD - Dólares Estadounidenses', value: 2}]"
          optionLabel="label"
          optionValue="value"
          styleClass="w-full"
          placeholder="Seleccionar moneda">
        </p-dropdown>
        <p class="text-sm text-gray-500 mt-1">Las cuotas del plan de pagos se calcularán en esta moneda.</p>
      </div>
    </form>

    <div class="flex justify-between mt-6">
      <button (click)="prevStep()" class="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
        Anterior
      </button>
      <button 
        (click)="nextStep()" 
        [disabled]="getActiveTotal() <= 0"
        class="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400">
        Continuar
      </button>
    </div>
  </div>

  <!-- Paso 5 (Nuevo Proyecto): Plan de Pagos -->
  <div *ngIf="currentStep === 5 && selectedEnrollment && !destinationForm.get('continueInSameProject')?.value" class="bg-white rounded-lg shadow-md p-6">
    <h2 class="text-lg font-semibold mb-4">Configurar Plan de Pagos</h2>
    <p class="text-gray-600 mb-6">Define el plan de pagos para la nueva inscripción</p>

    <!-- Resumen del valor -->
    <div class="bg-gray-50 p-4 rounded-lg mb-6">
      <div class="flex justify-between items-center">
        <span class="font-medium">Valor total de la inscripción:</span>
        <span class="text-xl font-bold text-green-600">
          {{ valueForm.get('currencyId')?.value === 1 ? formatCurrency(parseAmount(valueForm.get('newTotalValueCOP')?.value), 'COP') : formatCurrency(parseAmount(valueForm.get('newTotalValueUSD')?.value), 'USD') }}
        </span>
      </div>
    </div>

    <!-- Botón de generar automáticamente -->
    <div class="flex justify-between items-center mb-4">
      <span class="text-sm text-gray-600">{{ newPaymentPlan.length }} cuota(s) configuradas</span>
      <button 
        type="button"
        (click)="openRefinanceModal()"
        class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm flex items-center gap-2">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
        </svg>
        Generar Automáticamente
      </button>
    </div>

    <!-- Tabla de cuotas -->
    <div class="overflow-x-auto mb-4">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Cuota</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Fecha Vencimiento</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Monto</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Acciones</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let plan of newPaymentPlan; let i = index">
            <td class="px-4 py-3 text-sm font-medium text-gray-900">{{ plan.installmentNumber }}</td>
            <td class="px-4 py-3">
              <p-calendar 
                [(ngModel)]="plan.dueDate" 
                dateFormat="dd/mm/yy" 
                [showIcon]="true" 
                appendTo="body"
                styleClass="w-full">
              </p-calendar>
            </td>
            <td class="px-4 py-3">
              <input 
                type="text" 
                [(ngModel)]="plan.amount"
                appCurrencyFormatter
                class="w-32 px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent">
            </td>
            <td class="px-4 py-3">
              <button 
                type="button"
                (click)="removeInstallment(i)"
                [disabled]="newPaymentPlan.length <= 1"
                class="text-red-600 hover:text-red-800 disabled:text-gray-400 disabled:cursor-not-allowed">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                </svg>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Botón agregar cuota -->
    <button 
      type="button"
      (click)="addInstallment()"
      class="mb-4 text-sm text-blue-600 hover:text-blue-800 flex items-center gap-1">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
      </svg>
      Agregar Cuota
    </button>

    <!-- Validación del total -->
    <div class="p-4 rounded-lg mb-6" [ngClass]="isPlanValid ? 'bg-green-50' : 'bg-red-50'">
      <div class="flex justify-between items-center">
        <span class="font-medium" [ngClass]="isPlanValid ? 'text-green-700' : 'text-red-700'">Total del plan:</span>
        <span class="text-xl font-bold" [ngClass]="isPlanValid ? 'text-green-600' : 'text-red-600'">
          {{ valueForm.get('currencyId')?.value === 1 ? formatCurrency(currentPlanTotal, 'COP') : formatCurrency(currentPlanTotal, 'USD') }}
        </span>
      </div>
      <p *ngIf="!isPlanValid" class="text-sm text-red-600 mt-1">
        El total del plan debe coincidir con el valor de inscripción ({{ valueForm.get('currencyId')?.value === 1 ? formatCurrency(getActiveTotal(), 'COP') : formatCurrency(getActiveTotal(), 'USD') }})
      </p>
    </div>

    <div class="flex justify-between">
      <button (click)="prevStep()" class="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
        Anterior
      </button>
      <button 
        (click)="nextStep()" 
        [disabled]="!isPlanValid"
        class="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400">
        Continuar
      </button>
    </div>
  </div>

  <!-- Paso 6 (Nuevo Proyecto): Confirmar -->
  <div *ngIf="currentStep === 6 && selectedEnrollment && !destinationForm.get('continueInSameProject')?.value" class="bg-white rounded-lg shadow-md p-6">
    <h2 class="text-lg font-semibold mb-4">Confirmar Reversión</h2>
    
    <!-- Resumen -->
    <div class="bg-gray-50 rounded-lg p-4 mb-6">
      <h3 class="font-medium text-gray-700 mb-2">Resumen de la Reversión</h3>
      <div class="grid grid-cols-2 gap-4 text-sm">
        <div>
          <span class="text-gray-500">Participante:</span>
          <span class="ml-2 font-medium">{{ selectedEnrollment.participantName }}</span>
        </div>
        <div>
          <span class="text-gray-500">Proyecto original:</span>
          <span class="ml-2 font-medium">{{ selectedEnrollment.projectMnemonic }}</span>
        </div>
        <div>
          <span class="text-gray-500">Nuevo proyecto:</span>
          <span class="ml-2 font-medium text-blue-600">{{ getSelectedProject()?.projectId }} - {{ getSelectedProject()?.name }}</span>
        </div>
        <div>
          <span class="text-gray-500">Valor COP:</span>
          <span class="ml-2 font-medium">{{ formatCurrency(parseAmount(valueForm.get('newTotalValueCOP')?.value), 'COP') }}</span>
        </div>
        <div>
          <span class="text-gray-500">Valor USD:</span>
          <span class="ml-2 font-medium">{{ formatCurrency(parseAmount(valueForm.get('newTotalValueUSD')?.value), 'USD') }}</span>
        </div>
        <div>
          <span class="text-gray-500">Cuotas:</span>
          <span class="ml-2 font-medium">{{ newPaymentPlan.length }}</span>
        </div>
      </div>
    </div>

    <form [formGroup]="confirmForm" (ngSubmit)="submitReversal()">
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Razón de la reversión *</label>
        <textarea 
          formControlName="reason"
          rows="3"
          placeholder="Ingrese la razón de la reversión (mínimo 10 caracteres)"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent">
        </textarea>
      </div>

      <div class="mb-6">
        <label class="block text-sm font-medium text-gray-700 mb-1">Notas adicionales (opcional)</label>
        <textarea 
          formControlName="notes"
          rows="2"
          placeholder="Notas adicionales para auditoría"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent">
        </textarea>
      </div>

      <!-- Info -->
      <div class="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6">
        <div class="flex">
          <div class="flex-shrink-0">
            <svg class="h-5 w-5 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm text-blue-700">
              Se creará una nueva inscripción con los valores configurados. 
              <strong>Los pagos realizados permanecerán en el proyecto original.</strong>
            </p>
          </div>
        </div>
      </div>

      <div class="flex justify-between">
        <button type="button" (click)="prevStep()" class="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
          Anterior
        </button>
        <div class="flex items-center gap-3">
          <button type="button" (click)="cancel()" class="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
            Cancelar
          </button>
          <button 
            type="submit" 
            [disabled]="confirmForm.invalid || isSubmitting"
            class="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400 inline-flex items-center gap-2">
            <svg *ngIf="isSubmitting" class="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span *ngIf="isSubmitting">Procesando...</span>
            <span *ngIf="!isSubmitting">Confirmar Reversión</span>
          </button>
        </div>
      </div>
    </form>
  </div>

  <!-- Paso de Resultado Final (5 para mismo proyecto, 7 para nuevo proyecto) -->
  <div *ngIf="currentStep === resultStep" class="bg-white rounded-lg shadow-md p-6">
    <!-- Éxito -->
    <div *ngIf="operationSuccess" class="text-center">
      <div class="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-green-100 mb-6">
        <svg class="h-12 w-12 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
        </svg>
      </div>
      <h2 class="text-2xl font-bold text-gray-900 mb-2">¡Reversión Procesada Exitosamente!</h2>
      <p class="text-gray-600 mb-6">{{ operationResult?.message }}</p>

      <!-- Resumen de la operación -->
      <div class="bg-gray-50 rounded-lg p-6 text-left mb-6 max-w-lg mx-auto">
        <h3 class="font-semibold text-gray-800 mb-4 flex items-center gap-2">
          <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
          Resumen de la Reversión
        </h3>
        <div class="space-y-3">
          <div class="flex justify-between items-center py-2 border-b border-gray-200">
            <span class="text-gray-600">Participante:</span>
            <span class="font-medium">{{ selectedEnrollment?.participantName }}</span>
          </div>
          <div class="flex justify-between items-center py-2 border-b border-gray-200">
            <span class="text-gray-600">Proyecto Original:</span>
            <span class="font-medium">{{ selectedEnrollment?.projectMnemonic }}</span>
          </div>
          <div class="flex justify-between items-center py-2 border-b border-gray-200" *ngIf="operationResult?.newEnrollmentId">
            <span class="text-gray-600">Nueva Inscripción:</span>
            <span class="font-medium text-blue-600">#{{ operationResult?.newEnrollmentId }}</span>
          </div>
          <div class="flex justify-between items-center py-2 border-b border-gray-200" *ngIf="!destinationForm.get('continueInSameProject')?.value">
            <span class="text-gray-600">Nuevo Proyecto:</span>
            <span class="font-medium">{{ getSelectedProject()?.projectId }} - {{ getSelectedProject()?.name }}</span>
          </div>
          <div class="flex justify-between items-center py-2 border-b border-gray-200">
            <span class="text-gray-600">Cuotas Revertidas:</span>
            <span class="font-medium text-green-600">{{ operationResult?.affectedInstallmentsCount }} cuota(s)</span>
          </div>
          <div class="flex justify-between items-center py-2 border-b border-gray-200">
            <span class="text-gray-600">Monto Total Revertido:</span>
            <span class="font-bold text-green-600">{{ selectedEnrollment?.currencySymbol }}{{ operationResult?.totalAffectedAmount | number:'1.2-2' }}</span>
          </div>
          <div class="flex justify-between items-center py-2">
            <span class="text-gray-600">Nuevo Estado:</span>
            <span class="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm font-medium">Activa</span>
          </div>
        </div>
      </div>

      <!-- Botones de acción -->
      <div class="flex flex-col sm:flex-row gap-3 justify-center">
        <button 
          (click)="viewEnrollment()" 
          class="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center justify-center gap-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
          </svg>
          {{ operationResult?.newEnrollmentId ? 'Ver Nueva Inscripción' : 'Ver Inscripción' }}
        </button>
        <button 
          *ngIf="operationResult?.newEnrollmentId"
          (click)="viewOriginalEnrollment()" 
          class="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 flex items-center justify-center gap-2">
          Ver Inscripción Original
        </button>
        <button 
          (click)="startNewReversal()" 
          class="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 flex items-center justify-center gap-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
          </svg>
          Nueva Reversión
        </button>
        <button 
          (click)="goToEnrollmentsList()" 
          class="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 flex items-center justify-center gap-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16"/>
          </svg>
          Lista de Inscripciones
        </button>
      </div>
    </div>

    <!-- Error -->
    <div *ngIf="!operationSuccess" class="text-center">
      <div class="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-red-100 mb-6">
        <svg class="h-12 w-12 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </div>
      <h2 class="text-2xl font-bold text-gray-900 mb-2">Error al Procesar la Reversión</h2>
      <p class="text-red-600 mb-6">{{ operationError }}</p>

      <div class="flex flex-col sm:flex-row gap-3 justify-center">
        <button 
          (click)="currentStep = confirmationStep" 
          class="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center justify-center gap-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
          </svg>
          Volver a Intentar
        </button>
        <button 
          (click)="goToEnrollmentsList()" 
          class="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50">
          Cancelar
        </button>
      </div>
    </div>
  </div>

  <!-- Modal de Refinanciación -->
  <div *ngIf="showRefinanceModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
      <h3 class="text-lg font-semibold mb-4">Generar Plan de Pagos</h3>
      
      <div class="mb-6">
        <label class="block text-sm font-medium text-gray-700 mb-2">Número de cuotas</label>
        <input 
          type="range" 
          [(ngModel)]="refinanceInstallments"
          [min]="minInstallments" 
          [max]="maxInstallments"
          class="w-full">
        <div class="flex justify-between text-sm text-gray-500 mt-1">
          <span>{{ minInstallments }}</span>
          <span class="font-medium text-lg text-green-600">{{ refinanceInstallments }}</span>
          <span>{{ maxInstallments }}</span>
        </div>
      </div>

      <div class="bg-gray-50 p-4 rounded-lg mb-6">
        <div class="flex justify-between text-sm">
          <span class="text-gray-600">Valor por cuota (estimado):</span>
          <span class="font-medium">{{ valueForm.get('currencyId')?.value === 1 ? formatCurrency(getEstimatedInstallmentAmount() / refinanceInstallments * (newPaymentPlan.length || 2), 'COP') : formatCurrency(getEstimatedInstallmentAmount() / refinanceInstallments * (newPaymentPlan.length || 2), 'USD') }}</span>
        </div>
      </div>

      <div class="flex justify-end gap-3">
        <button 
          (click)="closeRefinanceModal()"
          class="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
          Cancelar
        </button>
        <button 
          (click)="confirmRefinance()"
          class="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700">
          Generar
        </button>
      </div>
    </div>
  </div>
</div>
